// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/suit-club.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/solid/suit-club'

import { Icon, type IconComponentProps } from '../icon'

export const SuitClubIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
